var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root" },
    [
      _c(
        "w-button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.goBackToCompaniesToolTipText,
              expression: "goBackToCompaniesToolTipText",
            },
          ],
          attrs: { flat: "", icon: "" },
          on: {
            click: function ($event) {
              return _vm.goBackToCompanies()
            },
          },
        },
        [_c("w-fa", { attrs: { icon: "arrow-left" } })],
        1
      ),
      _c("w-tabs", {
        attrs: { value: _vm.currentTab, tabs: _vm.tabs },
        on: {
          input: function ($event) {
            return _vm.setTab($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }